import React from 'react';

import OnboardingComponent from 'components/Onboarding';

const Onboarding: React.FC = () => <OnboardingComponent />;

export default Onboarding;
